import {NgModule} from '@angular/core'
import {LocationsMapComponent} from './locations-map.component'
import {PipesModule} from '../../shared/pipes/pipes.module'
import {CommonModule} from '@angular/common'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'
import {LocationCardComponent} from './location-card/location-card.component'
import {MapAddressComponent} from './map/map-address.component'
import {ChipComponent} from '../chip/chip.component'
import {GoogleRatingComponent} from '../google-rating/google-rating.component'
import {FullLocationPipe} from '../../shared/pipes/full-location.pipe'

@NgModule({
  declarations: [LocationsMapComponent, LocationCardComponent, MapAddressComponent],
  exports: [LocationsMapComponent, LocationCardComponent, MapAddressComponent],
  imports: [PipesModule, CommonModule, FontAwesomeModule, ChipComponent, GoogleRatingComponent, FullLocationPipe],
})
export class LocationsModule {}
